(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiet-atlas-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qap-quantity]');
    if (!button) return;
    const quantity = button.closest('.qap__quantity');
    const input = quantity?.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Math.max(1, Number(input.value) || 1);
    input.value = button.dataset.qapQuantity === 'increase' ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();
})();
